import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="bg-ink text-white px-4 sm:px-6 py-9 sm:py-12" data-id="element-20" data-mp="1of2ea2x0qe9o">
      <div className="max-w-3xl mx-auto" data-id="element-21" data-mp="22fwp0s7jgrbi">
        <p className="text-center font-heading font-semibold text-[10px] sm:text-xs uppercase tracking-[0.14em] text-white/50 mb-2" data-id="element-22" data-mp="22etxqj6b0mv2">
          And you're not just getting the core system.
        </p>

        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-center mb-6" data-id="element-23" data-mp="1aop5jycayvja">
          <span className="text-gold" data-id="element-24" data-mp="1jgr4fs6q43rg">5 premium bonuses</span> included today
        </h2>

        <ul className="flex flex-col gap-2 mb-5" data-id="element-25" data-mp="1jilnf0yfplsw">
          {bonuses.map(bonus => <li key={bonus.number} className="bg-white/[0.05] border border-gold/25 rounded-lg p-3.5 flex gap-3 items-start" data-id="element-26" data-mp="1eny2fc2n39j2">
              <div className="w-7 h-7 rounded bg-gold/15 border border-gold/30 flex items-center justify-center shrink-0" data-id="element-27" data-mp="my3ar8rb77r8">
                <GiftIcon className="w-3.5 h-3.5 text-gold" data-id="element-28" data-mp="29q0et16sc89m" />
              </div>
              <div className="min-w-0" data-id="element-29" data-mp="2eplexexoymnx">
                <p className="font-heading font-bold text-[9px] uppercase tracking-[0.16em] text-gold mb-1" data-id="element-30" data-mp="2jhwak5lefmao">
                  Bonus {bonus.number}
                </p>
                <h3 className="font-heading font-extrabold uppercase text-[13px] sm:text-base leading-tight tracking-tight mb-1" data-id="element-31" data-mp="2og7lkjnfk2uh">
                  {bonus.title}
                </h3>
                <p className="text-[12px] sm:text-sm text-white/65 leading-relaxed mb-2" data-id="element-32" data-mp="1vt3gkeoc7oip">
                  {bonus.description}
                </p>
                <ul className="flex flex-wrap gap-1" data-id="element-33" data-mp="25qhqdvfr9f21">
                  {bonus.tags.map(tag => <li key={tag} className="rounded bg-white/[0.06] border border-white/10 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-white/55" data-id="element-34" data-mp="3c6tuse967t62">
                      {tag}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>

        <p className="text-center font-heading font-bold uppercase text-[10px] sm:text-xs tracking-[0.12em] text-gold border border-gold/30 bg-gold/10 rounded-lg py-2.5 px-4" data-id="element-35" data-mp="1q43fagm4j3gy">
          All 5 bonuses are included with your access today.
        </p>
      </div>
    </section>;
}